function toggleKameleoonGoal(activeStep) {
    if (!window.KameleoonGoals) return;
    window.kameleoonQueue = window.kameleoonQueue || [];
    const goalsMap = [
        window.KameleoonGoals.FORM_FIRST_STEP,
        window.KameleoonGoals.FORM_SECOND_STEP,
        window.KameleoonGoals.FORM_THIRD_STEP,
        window.KameleoonGoals.FORM_FOURTH_STEP,
        window.KameleoonGoals.FORM_FIFTH_STEP,
        window.KameleoonGoals.FORM_SIXTH_STEP,
        window.KameleoonGoals.FORM_SEVENTH_STEP,
        window.KameleoonGoals.FORM_CONFIRMATION_STEP,
    ];
    const goal = goalsMap[activeStep];
    if (goal) {
        window.kameleoonQueue.push(['Goals.processConversion', goal]);
    }
}

function askDevisKameleoon() {
    window.kameleoonQueue = window.kameleoonQueue || [];
    if (window.KameleoonGoals && window.KameleoonGoals.ASK_DEVIS) {
        window.kameleoonQueue.push(['Goals.processConversion', window.KameleoonGoals.ASK_DEVIS]);
    }
}


function initKameleoon() {
    window.KameleoonGoals = {
        ASK_DEVIS: 401167,
        ASK_PHONE: 401168,
        FORM_FIRST_STEP: 401170,
        FORM_SECOND_STEP: 401172,
        FORM_THIRD_STEP: 401173,
        FORM_FOURTH_STEP: 401174,
        FORM_FIFTH_STEP: 401176,
        FORM_SIXTH_STEP: 401175,
        FORM_SEVENTH_STEP: 401177,
        FORM_CONFIRMATION_STEP: 401166
    };

    // Queue Initialization
    window.kameleoonQueue = window.kameleoonQueue || [];
    window.kameleoonStartLoadTime = new Date().getTime();
    
}

function initPhoneKameleoon() {
    const phone = document.querySelectorAll('.kameleoon-phone');
    phone.forEach(phone => {
        phone.addEventListener('click', () => {askDevisKameleoon
            window.kameleoonQueue.push(['Goals.processConversion', window.KameleoonGoals.ASK_PHONE]);
        });
    });
}

export { initKameleoon, initPhoneKameleoon, toggleKameleoonGoal, askDevisKameleoon };